import { Suspense } from "react";
import { SectionHeadingContainer } from "../SectionHeadingContainer/component";
import MainSchedule from "../../../../components/Schedule/components/MainSchedule/component";
import { isLinkVisible } from "../../utils/library";

/**
 * Renders a schedule widget
 *
 * @param {Object} params the widget params
 *
 * @returns {JSX} component structure for schedule widget
 */
const ScheduleContainer = ({ params }) => {
    const heading = (
        <SectionHeadingContainer
            title={params?.title}
            link={params.linkUrl}
            linkVisible={isLinkVisible(params.linkVisible)}
            description={params.description}
        />
    );
    return (
        <Suspense>
            <MainSchedule
                filter={params.filter}
                heading={heading}
                filterBar={(params?.showFilterBar && {}) || params?.filterBar}
            />
        </Suspense>
    );
};

export default ScheduleContainer;
